// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62a82845","455":"e6a85bec"}[chunkId] + ".chunk.js";
};